import parseSE from './se';
import parseFI from './fi';
import parseNO from './no';
import parseDK from './dk';
export var parse = function parse(bankAccount, market) {
  switch (market) {
    case 'se':
      return parseSE(bankAccount);
    case 'no':
      return parseNO(bankAccount);
    case 'fi':
      return parseFI(bankAccount);
    case 'dk':
      return parseDK(bankAccount);
    default:
      if (!market) {
        throw new Error('Undefined market');
      }
      throw new Error("".concat(market, " not recognized as a valid market."));
  }
};
export * from './constants';